import styled from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export const ScRecommendationsModal = styled.div<{ isEstonia: boolean }>`
  position: static;
  inset: auto 0 ${({ isEstonia }) => (isEstonia ? '48px' : '16px')} 0;
  z-index: 100;
  display: flex;

  & > div {
    display: flex;
    justify-content: space-between;
    padding: 0;
    gap: 8px;

    & > .category-btns {
      display: flex;
      gap: 8px;
    }
  }
`;

export const ScGamesCategoryModal = styled.div<{ isEstonia: boolean }>`
  position: fixed;
  inset: auto 0 ${({ isEstonia }) => (isEstonia ? '92px' : '60px')} 0;
  z-index: 100;

  & > div {
    width: 100%;
    background-color: ${({ theme }) => theme.grayLightColor};
    border-radius: 24px;
    padding: 16px;
    height: fit-content;
  }
`;

export const ScGamesCategoryModalBg = styled.div`
  position: fixed;
  z-index: 99;
  inset: 0;
  background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.8)};
`;
